module.exports = __webpack_public_path__ + "img/電気回路_1_9_4.10d02796.png";